import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  ContentWrapper,
  H2Styled
} from './GalleryPage.style';
import GalleryMealCard from './GalleryMealCard';
import GalleryPromotions from './GalleryPromotions';

const GalleryPageContent = ({
  galleryMeals,
  orderNowButtonText,
  promotions,
  showPromotionContent
  }) => {
  const renderGalleryPromotions = showPromotionContent &&
    GalleryPromotions({
      orderNowButtonText,
      promotions
    });

  const renderGalleryMeal = galleryMeals.map(meal =>
    <GalleryMealCard
      key={meal.uuid}
      meal={meal}
    />
  );

  return (
    <ContentWrapper data-rw="gallery-page--content">
      {renderGalleryPromotions}
      <H2Styled data-rw="gallery-page--header">
        <FormattedMessage id="gallery.subTitle" />
      </H2Styled>
      {renderGalleryMeal}
    </ContentWrapper>
  );
};

GalleryPageContent.propTypes = {
  galleryMeals: PropTypes.object.isRequired,
  orderNowButtonText: PropTypes.string.isRequired,
  promotions: PropTypes.object,
  showPromotionContent: PropTypes.bool.isRequired
};

export default GalleryPageContent;



// WEBPACK FOOTER //
// ./containers/GalleryPage/GalleryPageContent.js